module.exports = __webpack_public_path__ + "static/img/role-de.36499d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-2/role-de.png
// module id = qLR9
// module chunks = 1